import React from 'react';
import { Create } from 'react-admin';
import { t } from 'i18next';
import CustomCreateToolbar from '../CustomCreateToolbar';
import { NutrientGroupForm } from './NutrientGroupForm';

export const NutrientGroupCreate = props => (
  <Create {...props} title={t("nutrient_groups.title_create")}>
    <NutrientGroupForm toolbar={<CustomCreateToolbar user={props.options.currentUser.role}/>}/>
  </Create>
);
